    <template>
  <v-footer :dark="former.dark_theme" padless>
    <v-card-text
      class="py-2 text-center"
      :class="former.dark_theme ? 'white--text' : 'black--text'"
    >
      <v-img
        lazy-src="@/assets/logo.png"
        height="45"
        max-height="45"
        min-height="45"
        contain
        aspect-ratio="1"
        v-bind:src="imgr"
      ></v-img>

      <div style="justify-content='right'">
        <span
          >Copyright {{ new Date().getFullYear() }} —
          <a
            class="bubbalink"
            :class="former.dark_theme ? 'white--text' : 'black--text'"
            style="text-decoration: none"
            href="https://fyi.io"
            target="_blank"
            >Powered by fyiio</a
          ></span
        >
      </div>
    </v-card-text>
  </v-footer>
</template>
    <script>
export default {
  props: ["former", "imgr"],
};
</script>
<style scoped>
.center {
  display: flex;
  justify-content: center;
}
.bubbalink:hover {
  font-weight: bold;
}
</style>
